import APIService from '.';
import { BusinessWalletDashboard } from './interfaces/business-wallet-dashboard.interface';
import isRemoteLoading from '@/utils/remote-loading';

export enum EYourEarningsGroupByOption {
  ACCUMULATE = 'acumulate',
  OVERTIME = 'overtime'
}
export default class BusinessWalletService extends APIService {
  getDashboard() {
    return this.get<BusinessWalletDashboard>(
      `/admin/business-wallet/dashboard?includeCoinInCustomerWallet=${!isRemoteLoading()}`
    );
  }

  getYourCoinsSold(params: any) {
    return this.get('/admin/business-wallet/dashboard/your-coins-sold', {
      params
    });
  }

  getYourEarnings(params: any) {
    return this.get('/admin/business-wallet/dashboard/your-earnings', {
      params
    });
  }

  normalizeEarningsData(data: any, label: string, slug: string) {
    return {
      ...data,
      datasets: {
        ...data.datasets,
        label,
        slug
      }
    };
  }
}
